import { ProfileVisibilityField2 } from '@seek/profile-edit-ui';
import { useTranslations } from '@vocab/react';
import { Text, Stack, Loader, Heading } from 'braid-design-system';

import { useAnalytics } from 'src/modules/analytics/AnalyticsProvider';
import { useAppConfig } from 'src/modules/appConfig';

import { useGetProfileVisibility2, useUpdateProfileVisibility2 } from '../data';

import translations from './.vocab';
import { useProfileVisibilityOptions } from './data';

export const EditProfileVisibilitySettings = () => {
  const { t } = useTranslations(translations);
  const {
    profileVisibilityOptions,
    loading: loadingOptions,
    error: errorOptions,
  } = useProfileVisibilityOptions();
  const {
    profileVisibility2,
    loading: loading,
    error: error,
  } = useGetProfileVisibility2();
  const { profileVisibilityUpdate: profileVisibilityUpdateAnalytics } =
    useAnalytics();

  const [updateProfileVisibility2] = useUpdateProfileVisibility2();
  const { language, locale } = useAppConfig();

  const languageLocale = `${language}-${locale}`;

  const onChangeHandler = (newValue: string) => {
    updateProfileVisibility2({
      input: {
        id: newValue,
      },
      locale: languageLocale,
    });

    profileVisibilityUpdateAnalytics(newValue.toLowerCase());
  };

  const renderProfileVisibilityField2 = () =>
    loading ||
    error ||
    loadingOptions ||
    errorOptions ||
    !profileVisibilityOptions ||
    profileVisibilityOptions.length === 0 ? (
      <Loader size="small" data={{ testid: 'profile-visibility-loading' }} />
    ) : (
      <ProfileVisibilityField2
        options={profileVisibilityOptions}
        value={profileVisibility2?.id || ''}
        onChange={onChangeHandler}
      />
    );

  return (
    <Stack space="medium">
      <Heading level="4">{t('Set visibility')}</Heading>
      <Text tone="secondary">
        {t(`Control who can search your profile...`)}
      </Text>
      {renderProfileVisibilityField2()}
    </Stack>
  );
};
